"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPaymentMethodSchema = void 0;
const environments = __importStar(require("../../../../environments"));
const core = __importStar(require("../../../../core"));
const Mercoa = __importStar(require("../../../index"));
const url_join_1 = __importDefault(require("url-join"));
const serializers = __importStar(require("../../../../serialization/index"));
const errors = __importStar(require("../../../../errors/index"));
class CustomPaymentMethodSchema {
    constructor(_options) {
        this._options = _options;
    }
    /**
     * Get all custom payment method schemas
     *
     * @param {CustomPaymentMethodSchema.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Mercoa.BadRequest}
     * @throws {@link Mercoa.Unauthorized}
     * @throws {@link Mercoa.Forbidden}
     * @throws {@link Mercoa.NotFound}
     * @throws {@link Mercoa.Conflict}
     * @throws {@link Mercoa.InternalServerError}
     * @throws {@link Mercoa.Unimplemented}
     *
     * @example
     *     await client.customPaymentMethodSchema.getAll()
     */
    getAll(requestOptions) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.environment))) !== null && _a !== void 0 ? _a : environments.MercoaEnvironment.Production, "/paymentMethod/schema"),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@mercoa/javascript",
                    "X-Fern-SDK-Version": "0.6.6",
                    "User-Agent": "@mercoa/javascript/0.6.6",
                    "X-API-Version": (_d = (_b = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xApiVersion) !== null && _b !== void 0 ? _b : (_c = this._options) === null || _c === void 0 ? void 0 : _c.xApiVersion) !== null && _d !== void 0 ? _d : "2024-08-01",
                    "X-Fern-Runtime": core.RUNTIME.type,
                    "X-Fern-Runtime-Version": core.RUNTIME.version,
                },
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.customPaymentMethodSchema.getAll.Response.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch ((_e = _response.error.body) === null || _e === void 0 ? void 0 : _e["errorName"]) {
                    case "BadRequest":
                        throw new Mercoa.BadRequest(serializers.BadRequest.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unauthorized":
                        throw new Mercoa.Unauthorized(serializers.Unauthorized.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Forbidden":
                        throw new Mercoa.Forbidden(serializers.Forbidden.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "NotFound":
                        throw new Mercoa.NotFound(serializers.NotFound.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Conflict":
                        throw new Mercoa.Conflict(serializers.Conflict.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "InternalServerError":
                        throw new Mercoa.InternalServerError(serializers.InternalServerError.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unimplemented":
                        throw new Mercoa.Unimplemented(serializers.Unimplemented.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.MercoaError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.MercoaError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.MercoaTimeoutError();
                case "unknown":
                    throw new errors.MercoaError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Create custom payment method schema
     *
     * @param {Mercoa.CustomPaymentMethodSchemaRequest} request
     * @param {CustomPaymentMethodSchema.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Mercoa.BadRequest}
     * @throws {@link Mercoa.Unauthorized}
     * @throws {@link Mercoa.Forbidden}
     * @throws {@link Mercoa.NotFound}
     * @throws {@link Mercoa.Conflict}
     * @throws {@link Mercoa.InternalServerError}
     * @throws {@link Mercoa.Unimplemented}
     *
     * @example
     *     await client.customPaymentMethodSchema.create({
     *         name: "Wire",
     *         isSource: false,
     *         isDestination: true,
     *         supportedCurrencies: ["USD", "EUR"],
     *         fields: [{
     *                 name: "bankName",
     *                 displayName: "Bank Name",
     *                 type: "text",
     *                 optional: false
     *             }, {
     *                 name: "recipientName",
     *                 displayName: "Recipient Name",
     *                 type: "text",
     *                 optional: false
     *             }, {
     *                 name: "accountNumber",
     *                 displayName: "Account Number",
     *                 type: "usBankAccountNumber",
     *                 optional: false,
     *                 useAsAccountNumber: true
     *             }, {
     *                 name: "routingNumber",
     *                 displayName: "Routing Number",
     *                 type: "usBankRoutingNumber",
     *                 optional: false
     *             }],
     *         estimatedProcessingTime: 0,
     *         maxAmount: 100000,
     *         minAmount: 1
     *     })
     *
     * @example
     *     await client.customPaymentMethodSchema.create({
     *         name: "Check",
     *         isSource: false,
     *         isDestination: true,
     *         supportedCurrencies: ["USD"],
     *         fields: [{
     *                 name: "payToTheOrderOf",
     *                 displayName: "Pay To The Order Of",
     *                 type: "text",
     *                 optional: false
     *             }, {
     *                 name: "accountNumber",
     *                 displayName: "Account Number",
     *                 type: "usBankAccountNumber",
     *                 optional: false,
     *                 useAsAccountNumber: true
     *             }, {
     *                 name: "routingNumber",
     *                 displayName: "Routing Number",
     *                 type: "usBankRoutingNumber",
     *                 optional: false
     *             }, {
     *                 name: "address",
     *                 displayName: "Address",
     *                 type: "address",
     *                 optional: false
     *             }],
     *         estimatedProcessingTime: 7,
     *         maxAmount: 50000,
     *         minAmount: 1
     *     })
     */
    create(request, requestOptions) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.environment))) !== null && _a !== void 0 ? _a : environments.MercoaEnvironment.Production, "/paymentMethod/schema"),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@mercoa/javascript",
                    "X-Fern-SDK-Version": "0.6.6",
                    "User-Agent": "@mercoa/javascript/0.6.6",
                    "X-API-Version": (_d = (_b = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xApiVersion) !== null && _b !== void 0 ? _b : (_c = this._options) === null || _c === void 0 ? void 0 : _c.xApiVersion) !== null && _d !== void 0 ? _d : "2024-08-01",
                    "X-Fern-Runtime": core.RUNTIME.type,
                    "X-Fern-Runtime-Version": core.RUNTIME.version,
                },
                contentType: "application/json",
                requestType: "json",
                body: serializers.CustomPaymentMethodSchemaRequest.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.CustomPaymentMethodSchemaResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch ((_e = _response.error.body) === null || _e === void 0 ? void 0 : _e["errorName"]) {
                    case "BadRequest":
                        throw new Mercoa.BadRequest(serializers.BadRequest.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unauthorized":
                        throw new Mercoa.Unauthorized(serializers.Unauthorized.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Forbidden":
                        throw new Mercoa.Forbidden(serializers.Forbidden.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "NotFound":
                        throw new Mercoa.NotFound(serializers.NotFound.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Conflict":
                        throw new Mercoa.Conflict(serializers.Conflict.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "InternalServerError":
                        throw new Mercoa.InternalServerError(serializers.InternalServerError.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unimplemented":
                        throw new Mercoa.Unimplemented(serializers.Unimplemented.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.MercoaError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.MercoaError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.MercoaTimeoutError();
                case "unknown":
                    throw new errors.MercoaError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Update custom payment method schema
     *
     * @param {Mercoa.CustomPaymentMethodSchemaId} schemaId
     * @param {Mercoa.CustomPaymentMethodSchemaRequest} request
     * @param {CustomPaymentMethodSchema.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Mercoa.BadRequest}
     * @throws {@link Mercoa.Unauthorized}
     * @throws {@link Mercoa.Forbidden}
     * @throws {@link Mercoa.NotFound}
     * @throws {@link Mercoa.Conflict}
     * @throws {@link Mercoa.InternalServerError}
     * @throws {@link Mercoa.Unimplemented}
     *
     * @example
     *     await client.customPaymentMethodSchema.update("cpms_14f78dcd-4614-426e-a37a-7af262431d41", {
     *         name: "Check",
     *         isSource: false,
     *         isDestination: true,
     *         supportedCurrencies: ["USD"],
     *         fields: [{
     *                 name: "payToTheOrderOf",
     *                 displayName: "Pay To The Order Of",
     *                 type: "text",
     *                 optional: false
     *             }, {
     *                 name: "accountNumber",
     *                 displayName: "Account Number",
     *                 type: "usBankAccountNumber",
     *                 optional: false,
     *                 useAsAccountNumber: true
     *             }, {
     *                 name: "routingNumber",
     *                 displayName: "Routing Number",
     *                 type: "usBankRoutingNumber",
     *                 optional: false
     *             }, {
     *                 name: "address",
     *                 displayName: "Address",
     *                 type: "address",
     *                 optional: false
     *             }],
     *         estimatedProcessingTime: 7,
     *         maxAmount: 50000,
     *         minAmount: 1
     *     })
     *
     * @example
     *     await client.customPaymentMethodSchema.update("cpms_14f78dcd-4614-426e-a37a-7af262431d41", {
     *         name: "Wire",
     *         isSource: false,
     *         isDestination: true,
     *         supportedCurrencies: ["USD", "EUR"],
     *         fields: [{
     *                 name: "bankName",
     *                 displayName: "Bank Name",
     *                 type: "text",
     *                 optional: false
     *             }, {
     *                 name: "recipientName",
     *                 displayName: "Recipient Name",
     *                 type: "text",
     *                 optional: false
     *             }, {
     *                 name: "accountNumber",
     *                 displayName: "Account Number",
     *                 type: "usBankAccountNumber",
     *                 optional: false,
     *                 useAsAccountNumber: true
     *             }, {
     *                 name: "routingNumber",
     *                 displayName: "Routing Number",
     *                 type: "usBankRoutingNumber",
     *                 optional: false
     *             }],
     *         estimatedProcessingTime: 0,
     *         maxAmount: 100000,
     *         minAmount: 1
     *     })
     */
    update(schemaId, request, requestOptions) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.environment))) !== null && _a !== void 0 ? _a : environments.MercoaEnvironment.Production, `/paymentMethod/schema/${encodeURIComponent(serializers.CustomPaymentMethodSchemaId.jsonOrThrow(schemaId))}`),
                method: "POST",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@mercoa/javascript",
                    "X-Fern-SDK-Version": "0.6.6",
                    "User-Agent": "@mercoa/javascript/0.6.6",
                    "X-API-Version": (_d = (_b = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xApiVersion) !== null && _b !== void 0 ? _b : (_c = this._options) === null || _c === void 0 ? void 0 : _c.xApiVersion) !== null && _d !== void 0 ? _d : "2024-08-01",
                    "X-Fern-Runtime": core.RUNTIME.type,
                    "X-Fern-Runtime-Version": core.RUNTIME.version,
                },
                contentType: "application/json",
                requestType: "json",
                body: serializers.CustomPaymentMethodSchemaRequest.jsonOrThrow(request, {
                    unrecognizedObjectKeys: "strip",
                }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.CustomPaymentMethodSchemaResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch ((_e = _response.error.body) === null || _e === void 0 ? void 0 : _e["errorName"]) {
                    case "BadRequest":
                        throw new Mercoa.BadRequest(serializers.BadRequest.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unauthorized":
                        throw new Mercoa.Unauthorized(serializers.Unauthorized.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Forbidden":
                        throw new Mercoa.Forbidden(serializers.Forbidden.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "NotFound":
                        throw new Mercoa.NotFound(serializers.NotFound.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Conflict":
                        throw new Mercoa.Conflict(serializers.Conflict.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "InternalServerError":
                        throw new Mercoa.InternalServerError(serializers.InternalServerError.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unimplemented":
                        throw new Mercoa.Unimplemented(serializers.Unimplemented.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.MercoaError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.MercoaError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.MercoaTimeoutError();
                case "unknown":
                    throw new errors.MercoaError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Get custom payment method schema
     *
     * @param {Mercoa.CustomPaymentMethodSchemaId} schemaId
     * @param {CustomPaymentMethodSchema.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Mercoa.BadRequest}
     * @throws {@link Mercoa.Unauthorized}
     * @throws {@link Mercoa.Forbidden}
     * @throws {@link Mercoa.NotFound}
     * @throws {@link Mercoa.Conflict}
     * @throws {@link Mercoa.InternalServerError}
     * @throws {@link Mercoa.Unimplemented}
     *
     * @example
     *     await client.customPaymentMethodSchema.get("cpms_14f78dcd-4614-426e-a37a-7af262431d41")
     */
    get(schemaId, requestOptions) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.environment))) !== null && _a !== void 0 ? _a : environments.MercoaEnvironment.Production, `/paymentMethod/schema/${encodeURIComponent(serializers.CustomPaymentMethodSchemaId.jsonOrThrow(schemaId))}`),
                method: "GET",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@mercoa/javascript",
                    "X-Fern-SDK-Version": "0.6.6",
                    "User-Agent": "@mercoa/javascript/0.6.6",
                    "X-API-Version": (_d = (_b = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xApiVersion) !== null && _b !== void 0 ? _b : (_c = this._options) === null || _c === void 0 ? void 0 : _c.xApiVersion) !== null && _d !== void 0 ? _d : "2024-08-01",
                    "X-Fern-Runtime": core.RUNTIME.type,
                    "X-Fern-Runtime-Version": core.RUNTIME.version,
                },
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return serializers.CustomPaymentMethodSchemaResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    breadcrumbsPrefix: ["response"],
                });
            }
            if (_response.error.reason === "status-code") {
                switch ((_e = _response.error.body) === null || _e === void 0 ? void 0 : _e["errorName"]) {
                    case "BadRequest":
                        throw new Mercoa.BadRequest(serializers.BadRequest.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unauthorized":
                        throw new Mercoa.Unauthorized(serializers.Unauthorized.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Forbidden":
                        throw new Mercoa.Forbidden(serializers.Forbidden.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "NotFound":
                        throw new Mercoa.NotFound(serializers.NotFound.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Conflict":
                        throw new Mercoa.Conflict(serializers.Conflict.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "InternalServerError":
                        throw new Mercoa.InternalServerError(serializers.InternalServerError.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unimplemented":
                        throw new Mercoa.Unimplemented(serializers.Unimplemented.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.MercoaError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.MercoaError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.MercoaTimeoutError();
                case "unknown":
                    throw new errors.MercoaError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    /**
     * Delete custom payment method schema. Schema that have been used in an invoice cannot be deleted.
     *
     * @param {Mercoa.CustomPaymentMethodSchemaId} schemaId
     * @param {CustomPaymentMethodSchema.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Mercoa.BadRequest}
     * @throws {@link Mercoa.Unauthorized}
     * @throws {@link Mercoa.Forbidden}
     * @throws {@link Mercoa.NotFound}
     * @throws {@link Mercoa.Conflict}
     * @throws {@link Mercoa.InternalServerError}
     * @throws {@link Mercoa.Unimplemented}
     *
     * @example
     *     await client.customPaymentMethodSchema.delete("cpms_14f78dcd-4614-426e-a37a-7af262431d41")
     */
    delete(schemaId, requestOptions) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const _response = yield core.fetcher({
                url: (0, url_join_1.default)((_a = (yield core.Supplier.get(this._options.environment))) !== null && _a !== void 0 ? _a : environments.MercoaEnvironment.Production, `/paymentMethod/schema/${encodeURIComponent(serializers.CustomPaymentMethodSchemaId.jsonOrThrow(schemaId))}`),
                method: "DELETE",
                headers: {
                    Authorization: yield this._getAuthorizationHeader(),
                    "X-Fern-Language": "JavaScript",
                    "X-Fern-SDK-Name": "@mercoa/javascript",
                    "X-Fern-SDK-Version": "0.6.6",
                    "User-Agent": "@mercoa/javascript/0.6.6",
                    "X-API-Version": (_d = (_b = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xApiVersion) !== null && _b !== void 0 ? _b : (_c = this._options) === null || _c === void 0 ? void 0 : _c.xApiVersion) !== null && _d !== void 0 ? _d : "2024-08-01",
                    "X-Fern-Runtime": core.RUNTIME.type,
                    "X-Fern-Runtime-Version": core.RUNTIME.version,
                },
                contentType: "application/json",
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return;
            }
            if (_response.error.reason === "status-code") {
                switch ((_e = _response.error.body) === null || _e === void 0 ? void 0 : _e["errorName"]) {
                    case "BadRequest":
                        throw new Mercoa.BadRequest(serializers.BadRequest.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unauthorized":
                        throw new Mercoa.Unauthorized(serializers.Unauthorized.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Forbidden":
                        throw new Mercoa.Forbidden(serializers.Forbidden.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "NotFound":
                        throw new Mercoa.NotFound(serializers.NotFound.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Conflict":
                        throw new Mercoa.Conflict(serializers.Conflict.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "InternalServerError":
                        throw new Mercoa.InternalServerError(serializers.InternalServerError.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    case "Unimplemented":
                        throw new Mercoa.Unimplemented(serializers.Unimplemented.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            breadcrumbsPrefix: ["response"],
                        }));
                    default:
                        throw new errors.MercoaError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.MercoaError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                    });
                case "timeout":
                    throw new errors.MercoaTimeoutError();
                case "unknown":
                    throw new errors.MercoaError({
                        message: _response.error.errorMessage,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            return `Bearer ${yield core.Supplier.get(this._options.token)}`;
        });
    }
}
exports.CustomPaymentMethodSchema = CustomPaymentMethodSchema;
